import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IsNotSaved from '../IsNotSaved';
import useUpdateState from '../hooks/useUpdateState';
import ProjectDetailRow from './ProjectDetailRow';
import ProjectDetailsContractors from './ProjectDetailsContractors';
import ProjectDetailsTopPageData from './ProjectDetailsTopPageData';
const listVersion7 = [{
  name: 'iihrde_number_of_times_associated',
  translationKey: 'iihrde_number_of_times_associated'
}, {
  name: 'iihrde_corresponds_by_head',
  translationKey: 'iihrde_corresponds_by_head'
}, {
  name: 'iihrde_proportion_of_gross_wages_with_wage_tax',
  translationKey: 'iihrde_proportion_of_gross_wages_with_wage_tax'
}, {
  name: 'iihrde_gross_salary',
  translationKey: 'iihrde_gross_salary'
}, {
  name: 'iihrde_gs_received_by_employees_not_in_20_26',
  translationKey: 'of_which_received_by_employees_not_in_01jul2020till30jun2026'
}, {
  name: 'iihrde_gs_received_by_employees_in_20_26',
  translationKey: 'of_which_received_by_employees_30jun2020till01jul2026'
}, {
  name: 'iihrde_proportion_of_gross_wages_no_wage_tax',
  translationKey: 'iihrde_proportion_of_gross_wages_no_wage_tax'
}, {
  name: 'iihrde_pgs_not_in_20_26',
  translationKey: 'of_which_received_by_employees_not_in_01jul2020till30jun2026'
}, {
  name: 'iihrde_pgs_in_20_26',
  translationKey: 'of_which_received_by_employees_30jun2020till01jul2026'
}, {
  name: 'iihrde_prorota_expenditure',
  translationKey: 'iihrde_prorota_expenditure'
}, {
  name: 'iihrde_prorota_expenditure_not_in_20_26',
  translationKey: 'iihrde_prorota_expenditure_not_in_20_26'
}, {
  name: 'iihrde_prorota_expenditure_in_20_26',
  translationKey: 'iihrde_prorota_expenditure_in_20_26'
}, {
  name: 'ocp_research_carried_out',
  translationKey: 'ocp_research_carried_out'
}, {
  name: 'ocsp_working_hours',
  translationKey: 'ocsp_working_hours'
}, {
  name: 'ocsp_working_hours_not_in_20_26',
  translationKey: 'of_which_carried_out_not_in30jun2020till01jul2026'
}, {
  name: 'ocsp_working_hours_in_20_26',
  translationKey: 'of_which_carried_out_in30jun2020till01jul2026'
},
// { name: 'contractors_calculation', translationKey: 'contractors_calculation' },
{
  name: 'ic_rd_project_will_carried_with_affiliated_companies',
  translationKey: 'ic_rd_project_will_carried_with_affiliated_companies'
}, {
  name: 'ic_prop_carried_in_affiliated_companies',
  translationKey: 'ic_prop_carried_in_affiliated_companies'
}, {
  name: 'ic_rd_project_is_carried_with_taxexempt_research_institutions',
  translationKey: 'ic_rd_project_is_carried_with_taxexempt_research_institutions'
}, {
  name: 'ic_prop_carried_in_taxexempt_inst',
  translationKey: 'ic_prop_carried_in_taxexempt_inst'
}, {
  name: 'ic_rd_project_will_carried_with_other_taxable_comapnies',
  translationKey: 'ic_rd_project_will_carried_with_other_taxable_comapnies'
}, {
  name: 'ic_prop_carried_in_other_taxable_companies',
  translationKey: 'ic_prop_carried_in_other_taxable_companies'
}];
const calculationsVersion7 = ['iihrde_number_of_times_associated', 'iihrde_corresponds_by_head', 'iihrde_proportion_of_gross_wages_with_wage_tax', 'iihrde_gs_received_by_employees_not_in_20_26', 'iihrde_gs_received_by_employees_in_20_26', 'iihrde_proportion_of_gross_wages_no_wage_tax', 'iihrde_pgs_not_in_20_26', 'iihrde_pgs_in_20_26', 'iihrde_prorota_expenditure', 'iihrde_prorota_expenditure_not_in_20_26', 'iihrde_prorota_expenditure_in_20_26'];
const listVersion8 = [{
  name: 'iihrde_number_of_times_associated',
  translationKey: 'iihrde_number_of_times_associated'
}, {
  name: 'iihrde_corresponds_by_head',
  translationKey: 'iihrde_corresponds_by_head'
}, {
  name: 'iihrde_proportion_of_gross_wages_with_wage_tax',
  translationKey: 'iihrde_proportion_of_gross_wages_with_wage_tax'
}, {
  name: 'iihrde_gross_salary',
  translationKey: 'iihrde_gross_salary'
}, {
  name: 'iihrde_gs_received_by_employees_before_28_03_2024',
  translationKey: 'of_which_received_by_employees_before_28mar2024'
}, {
  name: 'iihrde_gs_received_by_employees_after_27_03_2024',
  translationKey: 'of_which_received_by_employees_after_27mar2024'
}, {
  name: 'iihrde_proportion_of_gross_wages_no_wage_tax',
  translationKey: 'iihrde_proportion_of_gross_wages_no_wage_tax'
}, {
  name: 'iihrde_pgs_not_before_28_03_2024',
  translationKey: 'of_which_received_by_employees_before_28mar2024'
}, {
  name: 'iihrde_pgs_in_after_27_03_2024',
  translationKey: 'of_which_received_by_employees_after_27mar2024'
}, {
  name: 'iihrde_prorota_expenditure',
  translationKey: 'iihrde_prorota_expenditure'
}, {
  name: 'iihrde_prorota_expenditure_before_28_03_2024',
  translationKey: 'of_which_received_by_employees_before_28mar2024'
}, {
  name: 'iihrde_prorota_expenditure_after_27_03_2024',
  translationKey: 'of_which_received_by_employees_after_27mar2024'
}, {
  name: 'ocp_research_carried_out',
  translationKey: 'ocp_research_carried_out'
}, {
  name: 'ocsp_working_hours',
  translationKey: 'ocsp_working_hours'
}, {
  name: 'ocsp_working_hours_before_28_03_2024',
  translationKey: 'of_which_carried_out_before28mar2024'
}, {
  name: 'ocsp_working_hours_after_27_03_2024',
  translationKey: 'of_which_carried_out_after_27mar2024'
},
// { name: 'contractors_calculation', translationKey: 'contractors_calculation' },
{
  name: 'ic_rd_project_will_carried_with_affiliated_companies',
  translationKey: 'ic_rd_project_will_carried_with_affiliated_companies'
}, {
  name: 'ic_prop_carried_in_affiliated_companies',
  translationKey: 'ic_prop_carried_in_affiliated_companies'
}, {
  name: 'ic_rd_project_is_carried_with_taxexempt_research_institutions',
  translationKey: 'ic_rd_project_is_carried_with_taxexempt_research_institutions'
}, {
  name: 'ic_prop_carried_in_taxexempt_inst',
  translationKey: 'ic_prop_carried_in_taxexempt_inst'
}, {
  name: 'ic_rd_project_will_carried_with_other_taxable_comapnies',
  translationKey: 'ic_rd_project_will_carried_with_other_taxable_comapnies'
}, {
  name: 'ic_prop_carried_in_other_taxable_companies',
  translationKey: 'ic_prop_carried_in_other_taxable_companies'
}];
const calculationsVersion8 = ['iihrde_number_of_times_associated', 'iihrde_corresponds_by_head', 'iihrde_proportion_of_gross_wages_with_wage_tax', 'iihrde_gs_received_by_employees_before_28_03_2024', 'iihrde_gs_received_by_employees_after_27_03_2024', 'iihrde_proportion_of_gross_wages_no_wage_tax', 'iihrde_pgs_not_before_28_03_2024', 'iihrde_pgs_in_after_27_03_2024', 'iihrde_prorota_expenditure', 'iihrde_prorota_expenditure_before_28_03_2024', 'iihrde_prorota_expenditure_after_27_03_2024'
// 'contractors_calculation',
];
const cooporeationFieldsToHide = ['ic_rd_project_is_carried_with_taxexempt_research_institutions', 'ic_prop_carried_in_taxexempt_inst', 'ic_rd_project_will_carried_with_other_taxable_comapnies', 'ic_prop_carried_in_other_taxable_companies'];
const ocpFieldsToHide = ['ocsp_working_hours', 'ocsp_working_hours_before_28_03_2024', 'ocsp_working_hours_after_27_03_2024', 'ocsp_working_hours_not_in_20_26', 'ocsp_working_hours_in_20_26'];
const ProjectDetails = _ref => {
  let {
    projectDetails,
    setProjectDetails,
    updateProjectDetails,
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [updateState] = useUpdateState(setProjectDetails, setIsNotSaved);
  const saveData = async body => {
    await updateProjectDetails(body);
    setIsNotSaved(false);
  };
  if (!projectDetails) return /*#__PURE__*/React.createElement("div", null, t('loading...'));
  const isVersion8 = (elster === null || elster === void 0 ? void 0 : elster.version_number) === 'version_8';
  const list = isVersion8 ? listVersion8 : listVersion7;
  const listBasedOnProjectWithAffiliatedCompanies = projectDetails.ic_rd_project_will_carried_with_affiliated_companies !== true ? list.filter(field => !cooporeationFieldsToHide.includes(field.name)) : list;
  const listBasedOnProjectWithOcp = projectDetails.ocp_research_carried_out !== true ? listBasedOnProjectWithAffiliatedCompanies.filter(field => !ocpFieldsToHide.includes(field.name)) : listBasedOnProjectWithAffiliatedCompanies;
  const finalList = listBasedOnProjectWithOcp;
  const calculations = isVersion8 ? calculationsVersion8 : calculationsVersion7;
  const projectRows = finalList.map((field, index) => {
    if (calculations.includes(field.name) && field.name === 'contractors_calculation') {
      return /*#__PURE__*/React.createElement(ProjectDetailsContractors, {
        projectDetails: projectDetails,
        isVersion8: isVersion8,
        key: field.name + 'rowData'
      });
    } else if (calculations.includes(field.name)) {
      return /*#__PURE__*/React.createElement(ProjectDetailRow, {
        rowData: [field.name, projectDetails.calculations[field.name]],
        translationKey: field.translationKey,
        index: index,
        updateState: updateState,
        projectDetails: projectDetails,
        key: field.name + 'rowData',
        disabled: true,
        isVersion8: isVersion8
      });
    } else {
      return /*#__PURE__*/React.createElement(ProjectDetailRow, {
        rowData: [field.name, projectDetails[field.name]],
        translationKey: field.translationKey,
        index: index,
        updateState: updateState,
        projectDetails: projectDetails,
        key: field.name + 'rowData',
        hasTooltip: field.name === 'iihrde_gross_salary',
        tooltipText: field.name === 'iihrde_gross_salary' ? t('please_fill_in_manually_if_needed') : '',
        isVersion8: isVersion8
      });
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProjectDetailsTopPageData, {
    projectDetails: projectDetails,
    isVersion8: isVersion8,
    updateState: updateState
  }), projectRows, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [projectDetails]
  }));
};
export default ProjectDetails;